export default "__VITE_ASSET__Cqp3Fo1J__"